import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import helpIcon from "../../assets/help-icon.png";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "../../languages";

const InfoModal = ({
  text,
  cancelDefaultPosition,
  cancelEventPropagation,
  iconSize,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Button
        onClick={(e) => {
          setModalOpen(true);
          if (cancelEventPropagation) e?.stopPropagation();
        }}
        className="text-decoration-none bg-transparent border-none p-0"
        style={{
          right: iconSize ?? 40,
          top: iconSize ?? 40,
          position: cancelDefaultPosition ? "static" : "absolute",
        }}
      >
        <img
          src={helpIcon}
          height={iconSize ?? 40}
          width={iconSize ?? 40}
          className="object-fit-contain"
          alt="help"
        />
      </Button>
      <Modal
        fade={false}
        centered
        isOpen={modalOpen}
        toggle={() => setModalOpen((prev) => !prev)}
      >
        <ModalBody
          style={{ borderRadius: "30px" }}
          className="bg-primary-blue text-white px-lg-4 py-3"
        >
          <div className="d-flex align-items-center mb-4 justify-content-between ">
            <Button
              onClick={() => setModalOpen((prev) => !prev)}
              className="bg-white border-none text-black full-rounded p-0"
              style={{ height: 30, width: 30 }}
            >
              <RxCross2 size={20} />
            </Button>
            <h5 className="m-0">{t("info")}</h5>
            <div></div>
          </div>
          <div className="p-3 f-4 text-center">
            {text ? text : t("infoModalDefaultText")}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default InfoModal;
